import React from "react";
import { ArrowUpRight } from "lucide-react";
import { WHY_US } from "../mock/data";

const WhyUs = () => {
  return (
    <section id="why" className="relative py-24 lg:py-32 bg-[#07070A] overflow-hidden">
      <div className="absolute top-1/4 left-0 w-[450px] h-[450px] rounded-full bg-[#14E0BF]/6 blur-[140px]" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-[#F77F00]/6 blur-[140px]" />

      <div className="relative max-w-[1480px] mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="max-w-[820px] mb-20">
          <div className="inline-flex items-center gap-2 mb-6">
            <ArrowUpRight className="w-4 h-4 text-[#14E0BF]" />
            <span className="font-mono text-[11px] text-[#14E0BF] uppercase tracking-[0.2em]">
              Why kitchnworx
            </span>
          </div>
          <h2 className="text-white">
            <span className="font-display text-5xl lg:text-7xl leading-[0.95] block">
              FIVE REASONS
            </span>
            <span className="font-serif-display italic text-5xl lg:text-7xl leading-[0.95] block mt-1">
              we&rsquo;re <span className="text-[#14E0BF]">not</span> like the rest.
            </span>
          </h2>
        </div>

        {/* Magazine-style alternating cards */}
        <div className="space-y-3">
          {WHY_US.map((item, idx) => (
            <div
              key={item.id}
              className="group relative grid lg:grid-cols-12 gap-0 rounded-[28px] overflow-hidden border border-white/10 bg-[#14141B] hover:border-[#14E0BF]/40 hover:teal-glow transition-all duration-500"
            >
              {/* Index */}
              <div className="lg:col-span-1 px-6 lg:px-8 pt-6 lg:py-8 flex lg:flex-col lg:items-start items-center gap-3">
                <span className="font-serif-display italic text-5xl lg:text-7xl text-white/20 leading-none">
                  0{item.id}
                </span>
              </div>

              {/* Text */}
              <div className="lg:col-span-6 px-6 lg:px-4 lg:py-10 pb-6">
                <div className="flex items-center gap-2 mb-4">
                  <span className="font-mono text-[11px] text-[#F77F00] uppercase tracking-[0.18em]">
                    {item.label}
                  </span>
                  <span className="h-px flex-1 bg-white/10" />
                </div>
                <h3 className="font-display text-white text-2xl lg:text-4xl uppercase leading-[1.05] mb-4">
                  {item.title}
                </h3>
                <p className="text-white/65 text-base lg:text-lg leading-relaxed max-w-[520px]">
                  {item.description}
                </p>
                <div className="mt-6 inline-flex items-center gap-2 bg-[#14E0BF]/10 border border-[#14E0BF]/30 rounded-full px-4 py-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#14E0BF]" />
                  <span className="font-mono text-[11px] uppercase tracking-wider text-[#14E0BF]">
                    {item.metric}
                  </span>
                </div>
              </div>

              {/* Image */}
              <div className="lg:col-span-5 relative min-h-[280px] lg:min-h-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-[#14141B] via-[#14141B]/30 to-transparent lg:from-[#14141B] lg:via-[#14141B]/40" />
                <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-[#07070A]/70 backdrop-blur-md border border-white/15 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <ArrowUpRight className="w-4 h-4 text-white" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
